import { render, staticRenderFns } from "./MangeDownloadForms.vue?vue&type=template&id=938d55ba&scoped=true&"
import script from "./MangeDownloadForms.vue?vue&type=script&lang=js&"
export * from "./MangeDownloadForms.vue?vue&type=script&lang=js&"
import style0 from "./MangeDownloadForms.vue?vue&type=style&index=0&id=938d55ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938d55ba",
  null
  
)

export default component.exports